import config from '../config'
import http from '../http'

export default{

    // 获取系统短信模板
    getSystemTemplate:async function(payload) {
        const res = await http({
                url: config.GET_SYSTEM_TEMPLATE,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },



    // 添加自定义短信模板(400)
    addCustomMessageTemplate:async function(payload) {
        const res = await http({
                url: config.ADD_CUSTOM_MESSAGE_TEMPLATE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    // 短信通道开关接口
    openNoteChannel:async function(payload) {
        const res = await http({
                url: config.OPEN_NOTE_CHANNEL,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    // 更新当前用户选择模板
    updateUserSelectionTemplate:async function(payload) {
        const res = await http({
                url: config.UPDATE_USER_SELECTION_TEMPLATE,
                method: 'put',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    // 获取自定义模板列表
    getCustomTemplateList:async function(payload) {
        const res = await http({
                url: config.GET_CUSTOM_TEMPLATE_LIST,
                method: 'get',
                data:{
                    ...payload
                }
            })
            return res.data
    },


    // 删除自定义短信模板
    deleteCustomMessageTemplate:async function(payload) {
        const res = await http({
                url: config.DELETE_CUSTOM_MESSAGE_TEMPLATE,
                method: 'delete',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    // 查看店铺各个短信提醒通道的开关状态
    getNoteRemind:async function(payload) {
        const res = await http({
                url: config.GET_NOTE_CHANNEL,
                method: 'get',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    // 获取短信文本的计费条数和长度
    
    getNoteCustomTemplateCount:async function(payload) {
        const res = await http({
                url: config.GET_NOTE_TEMPLATE_COUNT,
                method: 'get',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    //发送测试短信
    sendNoteTest:async function(payload) {
        const res = await http({
                url: config.SEND_TEST_NOTE,
                method: 'post',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    // 得到商店选择的模板
    getShopChooseTemplate:async function(payload) {
        const res = await http({
                url: config.GET_SHOP_CHOOSE_TEMPLATE,
                method: 'get',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    //获取店铺的短信记录
    getNoteRecords:async function(payload) {
        const res = await http({
                url: config.GET_NOTE_RECORDS,
                method: 'get',
                data:{
                    ...payload
                }   
            })
            return res.data
    },

    //获取催付提醒后用户支付订单时间分析
    getPaymentStatistic:async function(payload) {
        const res = await http({
                url: config.GET_PAYMENT_STATISTIC,
                method: 'get',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    //通过过滤条件获取短信记录
    getNoteRecordBy:async function(payload) {
        const res = await http({
                url: config.GET_NOTE_RECORD_BY,
                method: 'get',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    setCodSwitch:async function(payload) {
        const res = await http({
                url: config.SET_COD_SWITCH,
                method: 'post',
                data:{
                    ...payload
                }
            })
            return res.data
    },
    getCodSwitch:async function(payload) {
        const res = await http({
                url: config.GET_COD_SWITCH,
                method: 'get',
                data:{
                    ...payload
                }
            })
            return res.data
    },
    
    getRemindSendCount:async function(payload) {
        const res = await http({
                url: config.GET_REMIND_SEND_COUNT,
                method: 'get',
                data:{
                    ...payload
                }
            })
            return res.data
    },

    //获取用户画像
    getBuyerAnalysis:async function(payload) {
        const res = await http({
                url: config.GET_BUYER_ANALYSIS,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    //获取某个买家的订单
    getBuyerOrder:async function(payload) {
        const res = await http({
                url: config.GET_BUYER_ORDERS,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    //获取用户画像分类
    getBuyerCategory:async function(payload) {
        const res = await http({
                url: config.GET_USER_CATEGORY,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    //获取某个用户下某个分类的所有买家
    getBuyerCategory:async function(payload) {
        const res = await http({
                url: config.GET_USER_CATEGORY_ALL_BUYER,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getSuccessPayCount:async function(payload) {
        const res = await http({
                url: config.GET_SUCCESS_PAY_COUNR,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getcustomgroup:async function(payload) {
        const res = await http({
                url: config.GET_CUSTOM_GROUP,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//获取用户自定义分组
    getcustomgroupuser:async function(payload) {
        const res = await http({
                url: config.GET_CUSTOM_GROUP_USER,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//获取用户自定义分组下的买家
    createcategory:async function(payload) {
        const res = await http({
                url: config.CREATE_CATEGORY,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//创建自定义分组
    detelecategory:async function(payload) {
        const res = await http({
                url: config.DELETE_CATEGORY,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//删除自定义分组
    insertconsumer:async function(payload) {
        const res = await http({
                url: config.INSERT_CONSUMER,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//向某个分组添加买家
    shareconsumer:async function(payload) {
        const res = await http({
                url: config.SHARE_CONSUMER,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//将某个买家在所属分组共享，一般用在黑名单
    deleteconsumer:async function(payload) {
        const res = await http({
                url: config.DELETE_CONSUMER,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//将某个买家在所属分组共享，一般用在黑名单
    updatecategory:async function(payload) {
        const res = await http({
                url: config.UPDATE_CATEGORY,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//将某个买家在所属分组共享，一般用在黑名单
    getusergroup:async function(payload) {
        const res = await http({
                url: config.GET_TUSERGROUP,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//获取当前买家所在的分组
    syncshopmessage:async function(payload) {
        const res = await http({
                url: config.SYNC_SHOPMESSAGE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//同步shop会话
    getauth:async function(payload) {
        const res = await http({
                url: config.GET_AUTH,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//查看某个店铺是否授权shopee v1版本
    getuserauto:async function(payload) {
        const res = await http({
                url: config.GET_USERAUTO,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//更新某个用户的自定义回复
    getuserreplay:async function(payload) {
        const res = await http({
                url: config.GET_USERREPLAY,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//获取某个用户的自定义自动回复

    getshopautomatic:async function(payload) {
        const res = await http({
                url: config.GET_SHOP_AUTOMATIC,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//获取店铺自动翻译设置

    updateshopautomatic:async function(payload) {
        const res = await http({
                url: config.UPDATE_SHOP_AUTOMATIC,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//更新店铺自动翻译设置

    getanswer:async function(payload) {
        const res = await http({
                url: config.GET_ANSWER,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//获取回答推荐

    answerbehavi:async function(payload) {
        const res = await http({
                url: config.ANSWER_BEHAVIOR,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//记录客服消息发送记录

    setantomatic:async function(payload) {
        const res = await http({
                url: config.SET_ANTOMATIC,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//更新店铺的自动回复日期设置

    getantomatic:async function(payload) {
        const res = await http({
                url: config.GET_ANTOMATIC,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//更新店铺的自动回复日期设置

    getvaild:async function(payload) {
                const res = await http({
                        url: config.GET_VAILDINFO,
                        method: 'get',
                        data:{
                            ...payload
                        }
                    })
                return res.data
            },//显示有效数据
        
            getUserInfo:async function(payload) {
                const res = await http({
                        url: config.GET_INFO_USER,
                        method: 'get',
                        data:{
                            ...payload
                        }
                    })
                return res.data
            },//显示进程(有数据正在计算才会返回进程)：
        
            getcaluct:async function(payload) {
                const res = await http({
                        url: config.GET_CALCULAT,
                        method: 'get',
                        data:{
                            ...payload
                        }
                    })
                return res.data
            },//发送请求即计算指标
        
            deductingter:async function(payload) {
                const res = await http({
                        url: config.DEDUCT_USER,
                        method: 'post',
                        data:{
                            ...payload
                        }
                    })
                return res.data
            },//超管扣除积分
}